import { Chip } from '../ds/index'

/** The lead score (0-100 from the yes/no scorecard): strong, middling or weak at a glance. */
export function ScoreChip({ score }: { score: number | null | undefined }) {
  if (score == null) return null
  const tone = score >= 70 ? 'accent' : score < 40 ? 'warn' : undefined
  return <Chip tone={tone} dot={score >= 70}>Score {score}</Chip>
}

export const WEIGHTS = [{ value: 1, label: 'Counts normal' }, { value: 2, label: 'Counts more' }, { value: 3, label: 'Counts most' }]
